import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/whatsapp': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M380.9 97.1c41.9 42 67.1 97.7 67.1 157 0 122.4-101.8 222-224.1 222h-0.1c-37.2 0-73.7-9.3-106.1-27l-117.7 30.9 31.5-115c-19.4-33.7-29.6-71.9-29.6-111 0-122.4 99.6-222 222-222 59.3 0 115.1 23.1 157 65.1zM223.9 438.7c101.7 0 186.6-82.8 186.6-184.6 0.1-49.3-21.3-95.6-56.1-130.5-34.8-34.9-81.1-54.1-130.4-54.1-101.8 0-184.6 82.8-184.6 184.5 0 34.9 9.7 68.8 28.2 98.2l4.4 7-18.6 68.1 69.8-18.3 6.7 4c28.3 16.8 60.8 25.7 94 25.7zM325.1 300.5c5.5 2.7 9.2 4.1 10.5 6.6 1.4 2.3 1.4 13.4-3.2 26.4-4.6 13-26.7 24.8-37.4 26.4-17.6 2.6-31.4 1.3-66.6-13.9-55.7-24.1-92-80.1-94.8-83.8-2.7-3.7-22.6-30.1-22.6-57.4s14.3-40.7 19.4-46.3c5.1-5.5 11.1-6.9 14.8-6.9s7.4 0 10.6 0.2c3.4 0.2 8-1.3 12.5 9.5 4.6 11.1 15.7 38.4 17.1 41.2 1.4 2.8 2.3 6 0.5 9.7-10.6 21.2-22 20.5-16.3 30.3 21.5 36.9 42.9 49.7 75.5 66 5.5 2.8 8.8 2.3 12-1.4 3.3-3.8 13.9-16.2 17.6-21.8 3.7-5.6 7.4-4.7 12.5-2.8 5.1 1.8 32.4 15.2 37.9 18z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/whatsapp.js
// module id = 1089
// module chunks = 0